export const filterConstants = {
  FETCH_SUBSERVICE: 'FETCH_SUBSERVICE',
  FETCH_ADDR_BUILDING: 'FETCH_ADDR_BUILDING',
  FETCH_ADDR_FLAT: 'FETCH_ADDR_FLAT',
  APPLY_METHOD_CREATING_REQUEST: 'APPLY_METHOD_CREATING_REQUEST',
  APPLY_PRIORITY_REQUEST: 'APPLY_PRIORITY_REQUEST',
  APPLY_WORKER: 'APPLY_WORKER',
  APPLY_EXECUTER: 'APPLY_EXECUTER',
  APPLY_CREATOR: 'APPLY_CREATOR',
  APPLY_PAYMENT_STATE: 'APPLY_PAYMENT_STATE',
  APPLY_COMPANY: 'APPLY_COMPANY',
  APPLY_STATUS: 'APPLY_STATUS',
  APPLY_SERVICE: 'APPLY_SERVICE_FILTER',
  APPLY_ADDR_STREET: 'APPLY_ADDR_STREET_FILTER',
  APPLY_ADDR_BUILDING: 'APPLY_ADDR_BUILDING',
  APPLY_WARRANTY: 'APPLY_WARRANTY',
  APPLY_NOT_WARRANTY: 'APPLY_NOT_WARRANTY',
  APPLY_POSS_WARRANTY: 'APPLY_POSS_WARRANTY',
  APPLY_RETRY: 'APPLY_RETRY',
  APPLY_CHARGEABLE: 'APPLY_CHARGEABLE',
  APPLY_IS_ORDER: 'APPLY_IS_ORDER',
  APPLY_EXPIRED_ONLY: 'APPLY_EXPIRED_ONLY',
  // APPLY_USER_CREATED: 'APPLY_USER_CREATED',
  APPLY_IMMEDIATE: 'APPLY_IMMEDIATE',
  APPLY_INTERNAL: 'APPLY_INTERNAL',
  APPLY_BADWORK: 'APPLY_BADWORK',
  APPLY_WAITING: 'APPLY_WAITING',
  APPLY_DISTRICT: 'APPLY_DISTRICT',
  APPLY_WARRANTY_ORG: 'APPLY_WARRANTY_ORG',
  APPLY_ADDRESS_FILTER: 'APPLY_ADDRESS_FILTER',
  APPLY_ATTACHMENT_FILTER: 'APPLY_ATTACHMENT_FILTER',
  SET_DATE_RANGE: 'REQUESTS_SET_DATE_RANGE',
  SET_DATE_RANGE_FIELD: 'SET_DATE_RANGE_FIELD',
  SET_RELATED_TO_EXPIRED: 'SET_RELATED_TO_EXPIRED',
  SET_FILTER_COMPANY: 'REQUESTS_SET_FILTER_COMPANY',
  SET_FILTER_WORKER: 'REQUESTS_SET_FILTER_WORKER',
  SET_FILTER_STAGE: 'SET_FILTER_STAGE',
  SET_FILTER_ACCEPTANCE_STATUSES: 'SET_FILTER_ACCEPTANCE_STATUSES',
  SET_FILTER_EXECUTER: 'SET_FILTER_EXECUTER',
  SET_FILTER_CREATOR: 'SET_FILTER_CREATOR',
  SET_FILTER_STATUS: 'REQUESTS_SET_FILTER_STATUS',
  SET_FILTER_SERVICE: 'REQUESTS_SET_FILTER_SERVICE',
  SET_FILTER_DISTRICT: 'SET_FILTER_DISTRICT',
  SET_SUBSERVICE_VALUE: 'SET_SUBSERVICE_FILTER_VALUE',
  SET_ADDR_BUILDING_VALUE: 'SET_ADDR_BUILDING_FILTER_VALUE',
  SET_ADDR_PORCH_VALUE: 'SET_ADDR_PORCH__FILTER_VALUE',
  SET_ADDR_TYPE_FLAT_VALUE: 'SET_ADDR_TYPE_FLAT_VALUE',
  SET_ADDR_FLOOR_VALUE: 'SET_ADDR_FLOOR_FILTER_VALUE',
  SET_ADDR_FLAT_VALUE: 'SET_ADDR_FLAT_FILTER_VALUE',
  SET_FLAT_VALUE_BY_PORCH_FLOOR: 'SET_FLAT_FILTER_VALUE_BY_PORCH_FLOOR',
  RESET_ADDR_VALUES: 'RESET_ADDR_FILTER_VALUES',
  SET_PHONE_VALUE: 'SET_PHONE_FILTER_VALUE',
  SET_CLIENT_NAME_VALUE: 'SET_CLIENT_NAME_FILTER_VALUE',
  SET_RATING_VALUE: 'SET_RATING_FILTER_VALUE',
  SET_REQUEST_RATING: 'SET_REQUEST_RATING',
  SET_REQUEST_STATUS: 'SET_REQUEST_STATUS',
  SET_REQUEST_EXECUTE_TIME: 'SET_REQUEST_EXECUTE_TIME',
  SET_REQUEST_INVOICE: 'SET_REQUEST_INVOICE',
  SET_REQUEST_EXECUTER: 'SET_REQUEST_EXECUTER',
  SET_REQUEST_MASTER: 'SET_REQUEST_MASTER',
  SET_REQUEST_SERVICE: 'SET_REQUEST_SERVICE',
  SET_REQUEST_ADDRESS: 'SET_REQUEST_ADDRESS',
  MARK_REQUEST_VIEWED: 'MARK_REQUEST_VIEWED',
  MARK_REQUEST_COMMENTED: 'MARK_REQUEST_COMMENTED',
  RESET_FILTER: 'RESET_FILTER',
  BACK_FILTER: 'BACK_FILTER',
  SWITCH_FAVORITES: 'SWITCH_FAVORITES',
  GET_SAVED_FILTERS_LIST: 'GET_SAVED_FILTERS_LIST',
  SAVE_FILTER: 'SAVE_FILTER',
  DELETE_FILTER: 'DELETE_FILTER',
  SELECT_SAVED_FILTER: 'SELECT_SAVED_FILTER',
  SELECT_DATE_RANGE: 'SELECT_DATE_RANGE',
  CLEAR_SAVE_FILTER_ERROR: 'CLEAR_SAVE_FILTER_ERROR',
  RETRIEVE_LAST_STATE: 'RETRIEVE_LAST_STATE',
  SET_STAGE_FLAT_VALUE: 'SET_STAGE_FLAT_VALUE',
  SET_STAGE_CURRENT_FLAT_VALUE: 'SET_STAGE_CURRENT_FLAT_VALUE',
  SET_ACCEPTANCE_STATUSES_FLAT_VALUE: 'SET_ACCEPTANCE_STATUSES_FLAT_VALUE',
  SET_VALUE_CKECKED_STAGE: 'SET_VALUE_CKECKED_STAGE',
  SET_FILTER_CHANGED: 'SET_REQUEST_FILTER_CHANGED',
  SELECT_ALERT_DATE_RANGE: 'SELECT_ALERT_DATE_RANGE',
};

export const apiKeysToFilterKeys = {
  dateRange: 'dateRange',
  alertDateRange: 'alertDateRange',
  selectedDateRange: 'selectedDateRange',
  dateRangeField: 'dateRangeField',
  valueDistrict: 'valueDistrict',
  valueCreator: 'valueCreator',
  valueCompany: 'valueCompany',
  valueWorker: 'valueWorker',
  valueExecuter: 'valueExecuter',
  valueStatus: 'valueStatus',
  valuePriority: 'valuePriorityRequest',
  valueSubservice: 'valueSubservice',
  valueService: 'valueService',
  valueCreationMethod: 'valueMethodCreatingRequest',
  valueAddrStreet: 'valueAddrStreet',
  valueAddrBuilding: 'valueAddrBuilding',
  valueAddrFlat: 'valueAddrFlat',
  valueAddrPorch: 'valueAddrPorch',
  valueAddrFloor: 'valueAddrFloor',
  valueWarrantyOrg: 'valueWarrantyOrg',
  rating: 'valueRating',
  valuePhone: 'valuePhone',
  valueClientName: 'valueClientName',
  warranty: 'warranty',
  notWarranty: 'notWarranty',
  possWarranty: 'possWarranty',
  retry: 'retry',
  chargeable: 'chargeable',
  expiredOnly: 'expiredOnly',
  userCreatedOnly: 'userCreatedOnly',
  immediate: 'immediate',
  badWork: 'badWork',
  waiting: 'waiting',
  internal: 'internal',
  attachmentFilter: 'attachmentFilter',
  isOrder: 'isOrder',
  addressStagesLifeCycle: 'valueStageFlat',
  addressStagesLifeCycleCurrent: 'valueStageCurrentFlat',
  acceptanceStatusAddressLifeCycle: 'valueAcceptanceStatusesFlat',
  valuePaymentState: 'valuePaymentState',
};

export const filterKeyAdapterPairs = [
  ['valuePriority', 'valuePriorityRequest'],
  ['valueCreationMethod', 'valueMethodCreatingRequest'],
  ['rating', 'valueRating'],
  ['addressStagesLifeCycle', 'valueStageFlat'],
  ['addressStagesLifeCycleCurrent', 'valueStageCurrentFlat'],
  ['acceptanceStatusAddressLifeCycle', 'valueAcceptanceStatusesFlat'],
];

export const deprecatedDateRangeValuesAdapter = {
  create_time: 1,
  execute_date: 0,
};
